import React, { useEffect, useState, Fragment } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty } from 'lodash';
import { round } from 'mathjs';

import './index.scss';
import Color from '@tool/color';
import HeadPDF from '../../component/head-pdf';
import Title from '../../component/title';
import moDifferent from './store';
import { DownFullIcon, UpIcon, DownIcon } from '@styled/icon';
import Empty from '@/component/empty';
import moUser from '@store/user';
import moIndex from '../../store/index';
import PDF from '../../component/pdf';
import FootPdf from '../../component/foot-pdf';

interface IProps {
  list: any[],
  page: number,
}
interface IState {}

const DButton = styled(Button)(() => ({
  display: 'inline-flex',
  alignItems: 'flex-end',
  margin: 0,
  padding: 0,

  '& span': {
    marginRight: '4px',
    fontSize: '20px',
    fontWeight: 600,
    lineHeight: 1,
    color: Color.primary,
  },
  '&:hover': { backgroundColor: Color.blackColor(0) },
}));

// 涨薪率 - 城市薪酬差异系数
const CityDifferent = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const { list, page } = props;
  const { list1 } = moDifferent;
  const { baseCity, industry, isMock } = moIndex;
  const { isLogin } = moUser;
  const descArr = [
    '统计说明：在相同行业、时间下，计算各个城市的通用岗位的平均薪酬。',
    '以某一城市的通用岗位的平均薪酬为基准，计算各个城市的薪酬系数，该薪酬系数即为城市薪酬差异系数。',
  ];

  const newRate = (value: any, digit: number = 1) => {
    // eslint-disable-next-line no-restricted-globals
    if (isNaN(value)) return '-';
    if (value === null || value === '' || value === undefined) return '-';
    if (value === 0) return 0;
    return `${round(value, digit)}`;
  };

  useEffect(() => {
    return () => {};
  }, []);

  return (
    <section className="city-different-pdf_3030">
      <section className="content-3030">
        {page === 1 ? (
          <p className="desc-3030" style={{ color: '#878787' }}>
            {descArr.map((text: any, ix: number) => (
              <span key={ix}>{text}</span>
            ))}
          </p>
        ) : null}

        {!isEmpty(list) ? (
          <section className="city-different_3030">
            <p className="line-015">
              <DButton>
                <span>{baseCity.name}</span>
                <DownFullIcon color={Color.da} />
              </DButton>
              <i className="text-11">基准城市</i>
            </p>
            <section className={[
              'content-10177',
              !isMock ? '' : 'mock-100',
            ].join(' ')}>
              <section className="content-1021">
                <p className="line-61">
                  <span>城市区域</span><span>城市</span><span>差异系数</span><span>较上年变化</span>
                </p>
                {list.map((item: any, index: number) => (
                  <section key={index} className="line-51">
                    <span className="span-11 span-15">{item.area}</span>
                    <section className="line-111">
                      {item.cityList?.map((child: any, idx: number) => (
                        <p key={idx} className="line-53">
                          <span className="span-13">{child.city}</span>
                          <span className="span-13 span-133">{child.diff}</span>
                          {child.rate > 0 ? (
                            <span className={[
                              'span-13 span-133 up-111',
                            ].join(' ')}>
                              <i><UpIcon /></i>
                              {newRate(child.rate)}
                            </span>
                          ) : null}
                          {child.rate < 0 ? (
                            <span className={[
                              'span-13 span-133 down-111',
                            ].join(' ')}>
                              <i><DownIcon /></i>
                              {newRate(child.rate)}
                            </span>
                          ) : null}
                          {child.rate === 0 ? (
                            <span className="span-13 span-133">
                              {newRate(child.rate)}
                            </span>
                          ) : null}
                        </p>
                      ))}
                    </section>
                  </section>
                ))}
              </section>
            </section>
          </section>
        ) : null}
        {(isEmpty(list) && page === 1) ? <Empty padding="50px 0" /> : null}
      </section>
    </section>
  );
};

export default observer(CityDifferent);
